import React from "react";

import { CollapseProps } from "antd";

import { Card, Collapse, Typography } from "components";

export type InfoAccordionItem = {
  key: string;
  label: string;
  content: React.ReactNode;
};

interface InfoAccordionProps {
  items: InfoAccordionItem[];
  className?: string;
  defaultActiveKey?: CollapseProps["defaultActiveKey"];
  activeKey?: CollapseProps["activeKey"];
  onChange?: CollapseProps["onChange"];
}

export const InfoAccordion = ({ items, className = "", defaultActiveKey, activeKey, onChange }: InfoAccordionProps) => {
  if (items.length === 0) {
    return null;
  }

  // Transform items to the format expected by Ant Design Collapse
  const collapseItems = items.map((item) => ({
    key: item.key,
    label: <Typography variant="paragraph-m">{item.label}</Typography>,
    children: (
      <Typography variant="paragraph-m" color="grey-600">
        {item.content}
      </Typography>
    ),
  }));

  return (
    <Card className={`info-accordion ${className}`.trim()}>
      <Collapse items={collapseItems} defaultActiveKey={defaultActiveKey} activeKey={activeKey} onChange={onChange} />
    </Card>
  );
};
